import { IconNames } from '@blueprintjs/icons';
import { InlineMessage } from '@strata/react-inline-message';

import { DownloadBox } from 'components/shared/DownloadBox';
import { Page } from 'components/shared/Page';
import { Section } from 'components/shared/Section';

const powerpointTemplates = [
    <DownloadBox
        key="1"
        title="General Presentation"
        description="Use for general PowerPoint presentations."
        fileType="POTX"
        fileSize="12.6 mb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/FMH-General-Presentation.potx"
    />,
];

const wordTemplates = [
    <DownloadBox
        key="2"
        title="Meeting Agenda"
        description="Use for meeting agendas presented to external clients and customers."
        fileType="DOCX"
        fileSize="4.4 mb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/Meeting-Agenda-Template.docx"
    />,
    <DownloadBox
        key="3"
        title="Letterhead"
        description="Use for formal external correspondence."
        fileType="DOTX"
        fileSize="92.9 kb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/FMH-Letterhead.dotx"
    />,
    <DownloadBox
        key="4"
        title="Multi-Page with Dark Cover Sheet"
        description="Use for general multi-page documents. e.g. User Guides"
        fileType="DOCX"
        fileSize="4.5 mb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/FMH-Template-Dark-Cover.docx"
    />,
    <DownloadBox
        key="5"
        title="Multi-Page with Light Cover Sheet"
        description="Use for general multi-page documents. e.g. User Guides"
        fileType="DOCX"
        fileSize="4.5 mb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/FMH-Template-Light-Cover.docx"
    />,
    <DownloadBox
        key="6"
        title="Short Form with Dark Footer"
        description="Use for short documents."
        fileType="DOCX"
        fileSize="4.3 mb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/FMH-Short-Form-Dark-Footer.docx"
    />,
    <DownloadBox
        key="7"
        title="Short Form with Light Footer"
        description="Use for short documents."
        fileType="DOCX"
        fileSize="4.3 mb"
        downloadUrl="https://sseasacdn.blob.core.windows.net/strata-website/FMH-Short-Form-Light-Footer.docx"
    />,
];

const otherTemplates = [
    <DownloadBox
        key="8"
        title="Lucidchart Diagrams"
        description="Use for Lucid chart flow diagrams."
        fileType="Web"
        icon={IconNames.SHARE}
        // eslint-disable-next-line no-secrets/no-secrets
        downloadUrl="https://lucid.app/lucidchart/fc1ba25a-6ecd-4a98-a67a-20d55e84c59b/edit?viewport_loc=-710%2C-55%2C5096%2C2662%2C0_0&invitationId=inv_446325da-8c6c-41be-a953-7d6a5132dc7f"
    />,
];

export const Templates = () => (
    <div>
        <Page
            pageTitle="Templates"
            pageDescription="This repository contains FMH brand approved templates. Using these templates will enable efficient document creation."
            pageContent={
                <>
                    <p>
                        As a best practice always re-download templates below to ensure your
                        communication will be up-to-date and on brand.
                    </p>
                    <div className="margin__top--medium">
                        <InlineMessage
                            wrapText
                            intent={InlineMessage.Intent.TIP}
                            title="Best Practice Tip"
                            label="If a file is going to be emailed externally, send as a PDF. PowerPoint and Word documents should not be emailed."
                        />
                    </div>
                    <Section title="PowerPoint Templates" contentArray={powerpointTemplates} />
                    <Section title="Word Templates" contentArray={wordTemplates} />
                    <Section title="Other Templates" contentArray={otherTemplates} />
                </>
            }
        />
    </div>
);
